export const getAddressFromCoords = async (lat, lon) => {
    try {
        const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`);
        const data = await response.json();
        return data.display_name || "Dirección no encontrada";
    } catch (error) {
        console.error("Error fetching address:", error);
        return "Error al obtener la dirección";
    }
};
